var map = {
	"./img-badge-Amelia.png": 1276,
	"./img-badge-Amelia@2x.png": 495,
	"./img-badge-Harper.png": 1277,
	"./img-badge-Harper@2x.png": 496,
	"./img-badge-Lamar.png": 1278,
	"./img-badge-Lamar@2x.png": 497,
	"./img-badge-Paco.png": 1279,
	"./img-badge-Paco@2x.png": 498,
	"./img-badge-Philo.png": 1280,
	"./img-badge-Philo@2x.png": 499,
	"./img-badge-Ruby.png": 1281,
	"./img-badge-Ruby@2x.png": 500,
	"./img-commPostNoPic.png": 501,
	"./img-nopic.png": 1282,
	"./img-nopic@2x.png": 502
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 741;



//////////////////
// WEBPACK FOOTER
// ./app/features/shared/images ^\.\/.*\.png$
// module id = 741
// module chunks = 0